import React, { useEffect, useState } from 'react';
import { Eye, Flame, Zap } from 'lucide-react';
// Live-feel social proof — numbers tick in real time to create urgency.
// Viewers count fluctuates ±2 every 6s. Buyers count slowly increments.
// Spots remaining slowly decrements. All within realistic bounds.
export function SocialProofBar() {
  const [viewers, setViewers] = useState(23);
  const [buyers, setBuyers] = useState(67);
  const [spots, setSpots] = useState(147);
  useEffect(() => {
    const id = setInterval(() => {
      setViewers(v => Math.max(18, Math.min(34, v + (Math.random() > 0.5 ? 1 : -1))));
      if (Math.random() > 0.85) setBuyers(b => b + 1);
      if (Math.random() > 0.9) setSpots(s => Math.max(80, s - 1));
    }, 6000);
    return () => clearInterval(id);
  }, []);
  return <section className="w-full py-4 md:py-5 px-4 md:px-6" style={{
    background: '#0F1F3D'
  }} data-id="element-292">
      <div className="max-w-6xl mx-auto" data-id="element-293">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 text-center text-white" data-id="element-294">
          <div className="flex items-center justify-center gap-2 sm:gap-2.5" data-id="element-295">
            <Eye className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" style={{
            color: '#F5A623'
          }} data-id="element-296" />
            <span className="text-xs sm:text-sm md:text-base" data-id="element-297">
              <span className="font-bold tabular-nums" style={{
              color: '#F5A623'
            }} data-id="element-298">
                {viewers}
              </span>{' '}
              osoby oglądają tę stronę teraz
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 sm:gap-2.5" data-id="element-299">
            <Flame className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" style={{
            color: '#F5A623'
          }} data-id="element-300" />
            <span className="text-xs sm:text-sm md:text-base" data-id="element-301">
              <span className="font-bold tabular-nums" style={{
              color: '#F5A623'
            }} data-id="element-302">
                {buyers}
              </span>{' '}
              trenerów kupiło dzisiaj
            </span>
          </div>
          <div className="flex items-center justify-center gap-2 sm:gap-2.5" data-id="element-303">
            <Zap className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" style={{
            color: '#F5A623'
          }} data-id="element-304" />
            <span className="text-xs sm:text-sm md:text-base" data-id="element-305">
              Zostało tylko{' '}
              <span className="font-bold tabular-nums" style={{
              color: '#F5A623'
            }} data-id="element-306">
                {spots}
              </span>{' '}
              miejsc z 200
            </span>
          </div>
        </div>
      </div>
    </section>;
}